import { render, staticRenderFns } from "./Vars.vue?vue&type=template&id=e8dede58&scoped=true&"
import script from "./Vars.vue?vue&type=script&lang=js&"
export * from "./Vars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dede58",
  null
  
)

export default component.exports